import "core-js";
import "./MuiClassNameSetup";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import WidgetApp from "./WidgetApp";
import { register, serviceWorkerConfig } from "./ServiceWorkerConfig";
import { initAnalytics } from "fe-common/analytics/analytics";
import { KahunaWidgetConfiguration } from "./d";
import {
  MainContainerDesktopId,
  MainContainerId,
  SettingsContainerId,
} from "fe-web-components/rtl/MainContainerId";
import {
  LocalStorageSettingsPage,
  SettingsPageProps,
} from "fe-web-components/settings/newSettings/localSroageSettingsPage";
import { MemoryRouter, Route } from "react-router";

initAnalytics(["UA-161588595-2", "f27708013603324547b162beb3d5a589"]);
const HELIX_CLINIC_ID = "8da4bffe-26ab-4fc1-94b8-f70246077959";

const rootElement = document.getElementById(MainContainerDesktopId);

if (rootElement) {
  ReactDOM.render(<App />, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
register();
serviceWorkerConfig();

window["initKahunPatient"] = (settings: KahunaWidgetConfiguration = null) => {
  // console.log("initKahunPatient", settings);
  const patientNode = document.getElementById(MainContainerId);
  const widgetSettings = patientNode?.attributes["settings"]?.value;
  if (!settings && !widgetSettings) return;

  const buttonLayout =
    (settings || {}).buttonLayout ||
    patientNode?.attributes["data-button-layout"]?.value ||
    "icon";
  const buttonText = patientNode?.attributes["data-button-text"]?.value;
  const windowAlignment =
    patientNode?.attributes["data-window-alignment"]?.value || "left";

  const config: KahunaWidgetConfiguration =
    settings || JSON.parse(widgetSettings || "{}");

  const combinedSettings = {
    ...config,
    buttonLayout,
    buttonText,
    windowAlignment,
  };
  // console.log(settings);

  // if in helix, disable zoom in page for better ui
  if (combinedSettings?.clinicId === HELIX_CLINIC_ID) {
    const head = document.head || document.getElementsByTagName("head")[0];
    const metaTag = document.createElement("meta");
    metaTag.setAttribute("name", "viewport");
    metaTag.setAttribute("content", "width=device-width, user-scalable=no");
    head.appendChild(metaTag);
  }

  ReactDOM.render(<WidgetApp {...combinedSettings} />, patientNode);
};

window["removeKahunPatient"] = () => {
  const patientNode = document.getElementById(MainContainerId);
  if (patientNode) {
    return ReactDOM.unmountComponentAtNode(patientNode);
  }
  return false;
};

window["addKahunSettings"] = (
  settingsPageProps: SettingsPageProps,
  initialPath: string,
) => {
  // console.log("addKahunSettings", settingsPageProps);
  const settingsNode = document.getElementById(SettingsContainerId);

  const Comp = (
    <MemoryRouter>
      <Route
        path={`${initialPath}/:key?`}
        render={() => (
          <LocalStorageSettingsPage ignoreRoles={true} {...settingsPageProps} />
        )}
      />
    </MemoryRouter>
  );

  ReactDOM.render(Comp, settingsNode);
};

window["removeKahunSettings"] = () => {
  const settingsNode = document.getElementById(SettingsContainerId);
  if (settingsNode) {
    return ReactDOM.unmountComponentAtNode(settingsNode);
  }
  return false;
};
